if (!window.customElements.get('clear-cart-button')) {
  window.customElements.define('clear-cart-button',   class ClearCartButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
        const button = this.querySelector('button');
        this.button = button;
        button.addEventListener('click', async () => {
            try {
                const response = await fetch('/cart/clear.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                
                if (response.ok) {
                    const newDom = await fetch(window.location.href);
                    const textDom = await newDom.text();
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(textDom, 'text/html');
                    const newDrawer = doc.querySelector('cart-drawer');
                    const oldDrawer = document.querySelector('cart-drawer');

                    if (oldDrawer && newDrawer) {
                        oldDrawer.innerHTML = newDrawer.innerHTML;
                        oldDrawer.classList.add('is-empty');
                    }
                }
            } catch (error) {
                console.error(error);
            }
        });
    }
  });
}